module.exports = __webpack_public_path__ + "img/numFive.df6495da.png";